import { gql } from "@apollo/client";

export const DELETE_MODULE_WEBHOOK = gql`
  mutation DeleteModuleWebhook($moduleId: ID!, $id: ID!) {
    webhooksIntegrationDelete(id: $id, stack: $moduleId) {
      id
    }
  }
`;
